import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

import { SellTreezService } from '@/services/sell-treez'
import { Param } from '@/models/params'
import { Workflow } from '@/models/sellTreez'

export const useSellTreezWorkflows = () => {
  const { sellTreezId } = useParams<Param>()
  const queryKey = ['sell-treez-workflows', sellTreezId]

  const getWorkflows = useCallback(async () => {
    const response = await SellTreezService.getSellTreezWorkflows(sellTreezId as string)
    return response.data as Workflow[]
  }, [sellTreezId])

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: getWorkflows,
    enabled: !!sellTreezId?.length,
  })

  return { workflows: data ?? [], isLoading, refetch }
}
